"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseName = exports.parseType = exports.formatInOut = exports.mixinArr = exports.replaceSlash = exports.isString = exports.isEmpty = exports.type = void 0;
const Const_1 = require("./Const");
exports.type = (obj) => Object.prototype.toString.call(obj).slice(8, -1);
exports.isEmpty = ((undef) => (obj) => (obj === undef || obj === null))();
exports.isString = (obj) => exports.type(obj) === 'String';
exports.replaceSlash = (str) => str.replace(/\//g, '.');
exports.mixinArr = (arr1, arr2) => {
    arr2.forEach((str) => {
        if (!arr1.includes(str)) {
            arr1.push(str);
        }
    });
};
function formatInOut(str) {
    if (exports.isEmpty(str) || str === 'V' || str === '')
        return null;
    let tempStr = str;
    let tempStrArr = tempStr.split('');
    let startIndex = 0;
    let endIndex = 0;
    const resultArr = [];
    let endTempIndex = 0;
    while (true) {
        endIndex = 1 + tempStrArr.findIndex((s, i) => (/[BCDFIJSZ;]/.test(s) && i >= endTempIndex));
        const sliceStr = tempStr.substr(startIndex, endIndex);
        if ((sliceStr.indexOf(';') > -1 && sliceStr.split('>').length === sliceStr.split('<').length)
            || /^\[?[BCDFIJSZ]$/.test(sliceStr)) {
            resultArr.push(parseType(sliceStr));
            tempStr = tempStr.substr(endIndex);
            tempStrArr = tempStrArr.slice(endIndex);
            startIndex = 0;
            endIndex = 0;
            endTempIndex = 0;
        }
        else {
            endTempIndex = endIndex;
        }
        if (endIndex >= tempStrArr.length)
            break;
    }
    return resultArr;
}
exports.formatInOut = formatInOut;
const baseReg = /^(\[*[BCDFIJSZ])$/;
const classReg = /^L([\w/$;]+);$/;
const LReg = /^([*L[\w/$<>;]+;)$/;
const genericReg = /^L([\w/;]+)<(L?[\w/<>$;]+;)+>;$/;
const inoutReg = /^\(([[\w/<>;]+;?)?\)([[\w|/|<|>|;]+;?)$/;
const TReg = /^<([\w:;/.]+)>\(([[\w/<>;.]+;?)?\)([[\w|/|<|>|;.]+;?)$/;
function parseType(name) {
    if (exports.isEmpty(name) || !exports.isString(name))
        return name;
    if (name === 'TT;')
        return 'java.lang.Object';
    if (Const_1.BaseTypeKeys.indexOf(name) > -1) {
        return Const_1.BaseType[name];
    }
    const classResult = name.match(classReg);
    if (classResult) {
        return exports.replaceSlash(classResult[1]);
    }
    if (name.indexOf('[') === 0) {
        return `${parseType(name.slice(1))}[]`;
    }
    const genericResult = name.match(genericReg);
    if (genericResult) {
        const [, type1, type2] = genericResult;
        if (type1.slice(-3) === 'Map') {
            const [key, value] = formatInOut(type2);
            return `${exports.replaceSlash(type1)}<${key},${value}>`;
        }
        return `${exports.replaceSlash(type1)}<${parseType(type2)}>`;
    }
}
exports.parseType = parseType;
function parseName(name) {
    if (exports.isEmpty(name))
        return name;
    const inoutResult = name.match(inoutReg);
    if (inoutResult) {
        const [, instr, outstr] = inoutResult;
        const inArr = formatInOut(instr);
        const outArr = formatInOut(outstr);
        return [inArr, outArr];
    }
    const classResult = name.match(classReg);
    if (classResult) {
        return exports.replaceSlash(classResult[1]);
    }
    const LResult = name.match(LReg);
    if (LResult) {
        return parseType(LResult[1]);
    }
    const TResult = name.match(TReg);
    if (TResult) {
        const [, T, inStr, outStr] = TResult;
        const inArr = formatInOut(inStr);
        const [key, value] = T.split(':');
        const outArr = formatInOut(outStr.replace(new RegExp(`${key}${key};`), value));
        return [inArr, outArr];
    }
    const baseResult = name.match(baseReg);
    if (baseResult) {
        return parseType(baseResult[1]);
    }
    return exports.replaceSlash(name);
}
exports.parseName = parseName;
